import type { CanvasserStatsItem } from '@signalvote/shared';
import { Skeleton } from '../ui/skeleton';

interface VendorShiftSummaryProps {
  canvasserStats: CanvasserStatsItem[];
  isLoading: boolean;
}

export function VendorShiftSummary({ canvasserStats, isLoading }: VendorShiftSummaryProps) {
  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-5 w-full" />
      </div>
    );
  }

  if (canvasserStats.length === 0) return null;

  const claimed = canvasserStats.reduce((sum, c) => sum + c.shiftsClaimed, 0);
  const completed = canvasserStats.reduce((sum, c) => sum + c.shiftsCompleted, 0);
  const noShows = canvasserStats.reduce((sum, c) => sum + c.shiftsNoShow, 0);
  const totalHours = canvasserStats.reduce((sum, c) => sum + c.hoursWorked, 0);
  const totalDoors = canvasserStats.reduce((sum, c) => sum + c.doorsKnocked, 0);

  const noShowPct = claimed > 0 ? ((noShows / claimed) * 100).toFixed(1) : null;
  const avgHours = completed > 0 ? (totalHours / completed).toFixed(1) : null;
  const avgDoors = completed > 0 ? (totalDoors / completed).toFixed(1) : null;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Shift Summary</h3>
      <div className="space-y-1 text-sm">
        <div data-testid="shift-summary-counts">
          <span className="text-muted-foreground">Claimed:</span>{' '}
          <span className="tabular-nums">{claimed}</span>
          <span className="text-muted-foreground"> · </span>
          <span className="text-muted-foreground">Completed:</span>{' '}
          <span className="tabular-nums">{completed}</span>
          <span className="text-muted-foreground"> · </span>
          <span className="text-muted-foreground">No-Shows:</span>{' '}
          <span className="tabular-nums">
            {noShowPct !== null ? `${noShows} (${noShowPct}%)` : `${noShows}`}
          </span>
        </div>
        <div data-testid="shift-summary-averages">
          <span className="text-muted-foreground">Avg hours/shift:</span>{' '}
          <span className="tabular-nums">{avgHours ?? 'N/A'}</span>
          <span className="text-muted-foreground"> · </span>
          <span className="text-muted-foreground">Avg doors/shift:</span>{' '}
          <span className="tabular-nums">{avgDoors ?? 'N/A'}</span>
        </div>
      </div>
    </div>
  );
}
